import { all, call, put, select } from 'redux-saga/effects';

import * as actions from './tasks-simple.actions';
import * as dialogService from '../../../dialog/dialog.saga-services';
import * as actionsMeetingTasks from '../meeting-tasks/meeting-tasks.actions';
import * as taskSimpleResourceService from '../../../resource/task-simple/task-simple.saga-service';
import * as actionsTaskSimple from '../tasks-simple/tasks-simple.actions';
import * as actionResourceTaskSimple from '../../../resource/task-simple/task-simple.actions';
import * as api from '../../../api/request-config/task.api';

import {
  IGoalStatusUpdate,
  ISaveTaskOrder,
  ITaskSimple,
  ITaskSimpleCreate,
  ITaskSimpleCreateForm,
  ITaskSimpleFromNotification,
  ITaskSimpleUpdate,
  ITaskSimpleUpdateForm,
} from '../../../resource/task-simple/task-simple.types';
import * as types from '../../../page/page-storage/tasks-simple/tasks-simple.types';
import { tasksSimplePageSelectors } from './tasks-simple.selectors';
import { IUser } from '../../../resource/user/user.types';
import { ISimpleTasks } from './tasks-simple.types';
import { IBoardItem, ICalendarItem, IMeetingItem, IMeetingTasks } from '../meeting-tasks/meeting-tasks.types';
import { meetingTasksPageSelectors } from '../meeting-tasks/meeting-tasks.selectors';
import * as checkListService from '../checklists/checkLists.saga-services';
import * as activitiesService from '../activities/activities.saga-services';
import { taskSimpleSelectors } from '../../../resource/task-simple/task-simple.selectors';
import { authSelectors } from '../../../auth/auth.selectors';
import { meetingBoardsPageSelectors } from '../meeting-boards/meeting-boards.selectors';
import { IMeetingBoards } from '../meeting-boards/meeting-boards.types';
import { DropResult } from 'react-beautiful-dnd';
import { IBoardList } from '../../../resource/boards/boardList/boardList.types';
import { IMeetingSimple } from '../../../resource/meeting-simple/meeting-simple.types';
import { selectWithParams } from '../../../../utils/selector.utils';
import { apiRequest } from '../../../api/api.saga-services';
import moment from 'moment';
import { IMeeting } from '../../../resource/meeting/meeting.types';
import { storeNotification } from '../../../resource/notification/notification.saga-service';
import { INotification } from '../../../resource/notification/notification.types';
import { notificationsPageSelectors } from '../notifications/notifications.selectors';
import { storeUnseenCount } from '../notifications/notifications.actions';
import { IAddAttachmentForm } from '../../../resource/task/task.types';
import { IActivity } from '../../../resource/activity/activity.types';
import { activitiesPageSelectors } from '../activities/activities.selectors';
import { clearActivity, storeActivities } from '../activities/activities.actions';
import { clearTaskModalStatuses } from '../../../task-modals/task-modals.actions';
import { storeActivity } from '../../../resource/activity/activity.saga-service';

export function* clearTasksSimple() {
  yield put(actions.clearTaskSimple());
}

export function* setupTasksSimple(userId: IUser['id']) {
  let tasksSimple: ITaskSimple[] = [];
  const myTasks: ISimpleTasks = { active: [], done: [] };
  const qi: ISimpleTasks = { active: [], done: [] };

  tasksSimple = (yield call(taskSimpleResourceService.getMyTasks, { userId })) as ITaskSimple[];
  yield put(tasksSimple ? actions.storeIsFetched() : actions.clearIsFetched());

  tasksSimple.forEach((task) => {
    if (isGoal(task)) {
      if (isActive(task)) {
        qi.active.push(task.id);
      } else {
        qi.done.push(task.id);
      }
    } else {
      if (isActive(task)) {
        myTasks.active.push(task.id);
      } else {
        myTasks.done.push(task.id);
      }
    }
  });

  yield put(actions.storeTasksSimple(myTasks));
  yield put(actions.storeQi(qi));
}

/**
 * Used to create goals from form
 */
export function* createFormTaskSimple(taskInfo: ITaskSimpleCreateForm) {
  const task = (yield call(
    taskSimpleResourceService.createTaskSimple,
    mapTaskSimpleFormToTaskSimpleCreate(taskInfo),
  )) as ITaskSimpleFromNotification;
  if (!task) {
    return;
  }
  const meetingTasksIds = (yield select(meetingTasksPageSelectors.selectMeetingTasks)) as IMeetingTasks;
  const newMeetingTasks: IMeetingTasks = { ...meetingTasksIds };

  yield call(addGoalToStore, task, newMeetingTasks);

  yield put(actionsMeetingTasks.storeMeetingTasks(meetingTasksIds));
  yield call(dialogService.closeDialog, 'taskFormDialog');
}

/**
 * Used to create tasks through forms
 */
export function* createTaskSimple(payload: { task: ITaskSimpleCreate }) {
  const task = (yield call(taskSimpleResourceService.createTaskSimple, payload.task)) as ITaskSimpleFromNotification;
  if (!task) {
    return;
  }

  const meetingTasksIds = (yield select(meetingTasksPageSelectors.selectMeetingTasks)) as IMeetingTasks;
  const newMeetingTasks: IMeetingTasks = { ...meetingTasksIds };

  yield call(addTaskToStore, task, newMeetingTasks);

  yield call(dialogService.closeDialog, 'trelloCardFormDialog');
  yield call(dialogService.closeDialog, 'dbTaskFormDialog');

  yield put(actions.storeCreatedTaskId(task.id));
}

/**
 * This function is invoked when updating a task through the form
 */
export function* updateTaskSimple(taskId: ITaskSimple['id'], taskInfo: ITaskSimpleUpdate) {
  const oldTask = (yield select(taskSimpleSelectors.selectResourceById, taskId)) as ITaskSimple;

  const meetingTasksIds = (yield select(meetingTasksPageSelectors.selectMeetingTasks)) as IMeetingTasks;
  const newMeetingTasks: IMeetingTasks = { ...meetingTasksIds };

  const myTasks = yield select(tasksSimplePageSelectors.selectMyTasks);
  const newMyTasks = { ...myTasks };
  const myQIs = yield select(tasksSimplePageSelectors.selectQis);
  const newMyQIs = { ...myQIs };
  if (oldTask.status !== taskInfo.status) {
    if (myTasks.active.includes(taskId)) {
      newMyTasks.done.unshift(taskId);
      newMyTasks.active = removeTaskIdFromList('active', newMyTasks, taskId);
    } else if (myTasks.done.includes(taskId)) {
      newMyTasks.active.push(taskId);
      newMyTasks.done = removeTaskIdFromList('done', newMyTasks, taskId);
    } else if (myQIs.active.includes(taskId)) {
      newMyQIs.done.unshift(taskId);
      newMyQIs.active = removeTaskIdFromList('active', newMyQIs, taskId);
    } else if (myQIs.done.includes(taskId)) {
      newMyQIs.active.push(taskId);
      newMyQIs.done = removeTaskIdFromList('done', newMyQIs, taskId);
    }
    yield put(actions.storeTasksSimple(newMyTasks));
    yield put(actions.storeQi(newMyQIs));
  }

  const updatedTask = (yield call(
    apiRequest,
    api.updateTaskApi(taskId, taskInfo),
  ) as unknown) as ITaskSimpleFromNotification;
  if (!updatedTask) {
    return;
  }

  yield call(updateTaskInStore, updatedTask, oldTask, newMeetingTasks);

  yield call(dialogService.closeDialog, 'taskFormDialog');
}

/**
 * @todo: apparently this method is for updating goals,
 * so in the future maybe this could be refactored, specifically the names
 *
 * used to update goals with FORMS
 */
export function* updateGoal(task: ITaskSimpleUpdateForm) {
  const taskInfo = { id: task.id, ...mapTaskSimpleFormToTaskSimpleCreate(task) };

  const oldTask = (yield select(taskSimpleSelectors.selectResourceById, task.id)) as ITaskSimple;

  const meetingTasksIds = (yield select(meetingTasksPageSelectors.selectMeetingTasks)) as IMeetingTasks;
  const newMeetingTasks: IMeetingTasks = { ...meetingTasksIds };

  const myTasks = yield select(tasksSimplePageSelectors.selectMyTasks);
  const newMyTasks = { ...myTasks };

  if (oldTask.status !== taskInfo.status) {
    if (myTasks.active.includes(taskInfo.id)) {
      newMyTasks.done.push(taskInfo.id);
      newMyTasks.active = removeTaskIdFromList('active', newMyTasks, taskInfo.id);
    } else if (myTasks.done.includes(taskInfo.id)) {
      newMyTasks.active.push(taskInfo.id);
      newMyTasks.done = removeTaskIdFromList('done', newMyTasks, taskInfo.id);
    }

    yield put(actions.storeTasksSimple(newMyTasks));
  }

  const updatedTask = (yield call(
    apiRequest,
    api.updateTaskApi(task.id, taskInfo),
  ) as unknown) as ITaskSimpleFromNotification;
  if (!updatedTask) {
    return;
  }

  yield call(updateGoalInStore, updatedTask, oldTask, newMeetingTasks);
  yield call(dialogService.closeDialog, 'taskFormDialog');
}

export function* updateGoalStatus(taskId: ITaskSimple['id'], data: IGoalStatusUpdate) {
  const newStatus = data.status as ITaskSimple['status'];
  const oldGoal = (yield select(taskSimpleSelectors.selectResourceById, taskId)) as ITaskSimple;

  const meetingTasksIds = (yield select(meetingTasksPageSelectors.selectMeetingTasks)) as IMeetingTasks;
  const newMeetingTasks: IMeetingTasks = { ...meetingTasksIds };

  const myTasks = yield select(tasksSimplePageSelectors.selectMyTasks);
  const newMyTasks = { ...myTasks };

  if (oldGoal.status !== newStatus) {
    if (myTasks.active.includes(taskId)) {
      newMyTasks.done.push(taskId);
      newMyTasks.active = removeTaskIdFromList('active', newMyTasks, taskId);
    } else if (myTasks.done.includes(taskId)) {
      newMyTasks.active.push(taskId);
      newMyTasks.done = removeTaskIdFromList('done', newMyTasks, taskId);
    }

    yield put(actions.storeTasksSimple(newMyTasks));
  }

  const updatedTask = (yield call(
    apiRequest,
    api.updateTaskApi(taskId, { status: newStatus }),
  ) as unknown) as ITaskSimpleFromNotification;
  if (!updatedTask) {
    return;
  }

  yield call(updateGoalInStore, updatedTask, oldGoal, newMeetingTasks);
}

/**
 * function that updates a task or goal after pusher notification
 */
export function* saveTaskSimpleSocket(tasksSimpleNotification: ITaskSimpleFromNotification) {
  const loggedUserId = (yield select(authSelectors.selectLoggedUser)) as IUser['id'];
  if (tasksSimpleNotification.changedBy === loggedUserId) {
    return;
  }

  const meetingTasksIds = (yield select(meetingTasksPageSelectors.selectMeetingTasks)) as IMeetingTasks;
  const taskSimpleIds = (yield select(taskSimpleSelectors.selectResourceIds)) as ITaskSimple['id'][];
  const tasksSimple = (yield select(taskSimpleSelectors.selectResourcesById, taskSimpleIds)) as ITaskSimple[];

  let newTasksSimple: ITaskSimple[];

  let taskSimpleToSave: ITaskSimple = tasksSimpleNotification;
  const existentTask = tasksSimple.find((task: ITaskSimple) => task.id === tasksSimpleNotification.id) as ITaskSimple;
  if (existentTask) {
    newTasksSimple = tasksSimple.map((task: ITaskSimple) => {
      if (task.id === tasksSimpleNotification.id) {
        taskSimpleToSave = { ...task, ...tasksSimpleNotification };
        return taskSimpleToSave;
      }
      return task;
    }) as ITaskSimple[];
  } else {
    newTasksSimple = tasksSimple.slice();
    newTasksSimple.push(tasksSimpleNotification);
  }

  yield put(actionResourceTaskSimple.storeTaskSimple(taskSimpleToSave));

  if (existentTask) {
    if (isGoal(existentTask)) {
      yield call(updateGoalInStore, tasksSimpleNotification, existentTask, meetingTasksIds);
    } else {
      yield call(updateTaskInStore, tasksSimpleNotification, existentTask, meetingTasksIds);
    }
  } else {
    if (isGoal(tasksSimpleNotification)) {
      yield call(addGoalToStore, tasksSimpleNotification, meetingTasksIds);
    } else {
      yield call(addTaskToStore, tasksSimpleNotification, meetingTasksIds);
    }
  }

  let notificationMessage: string;
  if (existentTask) {
    if (existentTask.taskTypeId === '1') {
      notificationMessage = 'A goal was updated';
    } else {
      notificationMessage = 'A card was updated';
    }
  } else {
    if (tasksSimpleNotification.taskTypeId === '1') {
      notificationMessage = 'A new goal was created';
    } else {
      notificationMessage = 'A new card was created';
    }
  }

  const notif: INotification = {
    id: String(Math.floor(Math.random() * 10000)),
    meetingId: tasksSimpleNotification.meetingIds[0],
    senderId: tasksSimpleNotification.changedBy,
    receiverId: loggedUserId,
    message: notificationMessage,
    createdAt: tasksSimpleNotification.notificationCreatedAt,
  };

  yield call(storeNewPusherNotification, notif);
}

export function* storeNewPusherNotification(notif: INotification) {
  yield call(storeNotification, notif);
  const unseenCount = (yield select(notificationsPageSelectors.selectUnseenCount)) as number;
  yield put(storeUnseenCount(unseenCount + 1));
}

export function* deleteTaskSimple(taskId: ITaskSimple['id']) {
  const oldTask = (yield select(taskSimpleSelectors.selectResourceById, taskId)) as ITaskSimple;

  const meetingTasksIds = (yield select(meetingTasksPageSelectors.selectMeetingTasks)) as IMeetingTasks;
  const newMeetingTasks: IMeetingTasks = { ...meetingTasksIds };

  const meetingBoards = (yield select(meetingBoardsPageSelectors.selectMeetingBoards)) as IMeetingBoards;
  const checkFetch = Object.keys(meetingBoards).some((meetingId) => oldTask.meetingIds.includes(meetingId));

  if (checkFetch) {
    if (oldTask.taskTypeId !== '1') {
      oldTask.meetingIds.forEach((meetingId) => {
        if (oldTask.taskTypeId !== '1' && !!oldTask.taskTypeId) {
          if (!!newMeetingTasks[meetingId].boardTasks[Number(oldTask.taskTypeId)]) {
            const taskStatuses = (newMeetingTasks[meetingId].boardTasks[
              Number(oldTask.taskTypeId)
            ] as unknown) as ISimpleTasks;
            if (isActive(oldTask)) {
              taskStatuses.active = removeTaskIdFromList('active', taskStatuses, oldTask.id);
              newMeetingTasks[meetingId].boardTasks[
                Number(oldTask.taskTypeId)
              ] = (taskStatuses as unknown) as IBoardItem;
            } else {
              taskStatuses.done = removeTaskIdFromList('done', taskStatuses, oldTask.id);
              newMeetingTasks[meetingId].boardTasks[
                Number(oldTask.taskTypeId)
              ] = (taskStatuses as unknown) as IBoardItem;
            }
          }
          meetingTasksIds[meetingId].boardTasks = newMeetingTasks[meetingId].boardTasks;
        }
      });
      oldTask.meetingIds.forEach((meetingId) => {
        if (isActionItem(oldTask)) {
          if (oldTask.members.length !== 0) {
            oldTask.members.forEach((member) => {
              if (!!newMeetingTasks[meetingId].actionItems[Number(member)]) {
                const taskStatuses = (newMeetingTasks[meetingId].actionItems[
                  Number(member)
                ] as unknown) as ISimpleTasks;
                if (isActive(oldTask)) {
                  taskStatuses.active = removeTaskIdFromList('active', taskStatuses, oldTask.id);
                  newMeetingTasks[meetingId].actionItems[Number(member)] = (taskStatuses as unknown) as IMeetingItem;
                } else {
                  taskStatuses.done = removeTaskIdFromList('done', taskStatuses, oldTask.id);
                  newMeetingTasks[meetingId].actionItems[Number(member)] = (taskStatuses as unknown) as IMeetingItem;
                }
              }
            });
          }
          meetingTasksIds[meetingId].actionItems = newMeetingTasks[meetingId].actionItems;
        }
      });
    }
    oldTask.meetingIds.forEach((meetingId) => {
      if (isGoal(oldTask)) {
        if (!!newMeetingTasks[meetingId]) {
          if (!!newMeetingTasks[meetingId].goals[Number(oldTask.userId)]) {
            const taskStatuses = (newMeetingTasks[meetingId].goals[Number(oldTask.userId)] as unknown) as ISimpleTasks;
            if (isActive(oldTask)) {
              taskStatuses.active = removeTaskIdFromList('active', taskStatuses, oldTask.id);
              newMeetingTasks[meetingId].goals[Number(oldTask.userId)] = (taskStatuses as unknown) as IMeetingItem;
            } else {
              taskStatuses.done = removeTaskIdFromList('done', taskStatuses, oldTask.id);
              newMeetingTasks[meetingId].goals[Number(oldTask.userId)] = (taskStatuses as unknown) as IMeetingItem;
            }
          }
          meetingTasksIds[meetingId].goals = newMeetingTasks[meetingId].goals;
        }
      }
    });
  }
  yield put(actionsMeetingTasks.storeMeetingTasks(meetingTasksIds));
  yield call(taskSimpleResourceService.deleteTaskSimple, taskId);
}

export function* deleteTaskSimpleSocket(payload: types.IDeleteTaskNotificationPayload) {
  const loggedUserId: IUser['id'] = yield select(authSelectors.selectLoggedUser);
  if (loggedUserId !== payload.changedBy) {
    const taskId = payload.id;
    const oldTask = (yield select(taskSimpleSelectors.selectResourceById, taskId)) as ITaskSimple;

    const meetingTasksIds = (yield select(meetingTasksPageSelectors.selectMeetingTasks)) as IMeetingTasks;
    const newMeetingTasks: IMeetingTasks = { ...meetingTasksIds };
    const meetingBoards = (yield select(meetingBoardsPageSelectors.selectMeetingBoards)) as IMeetingBoards;
    const checkFetch = Object.keys(meetingBoards).some((meetingId) => oldTask.meetingIds.includes(meetingId));
    if (!checkFetch) {
      return;
    }

    oldTask.meetingIds.forEach((meetingId) => {
      if (oldTask.taskTypeId !== '1' && !!oldTask.taskTypeId) {
        if (!!newMeetingTasks[meetingId].boardTasks[Number(oldTask.taskTypeId)]) {
          const taskStatuses = (newMeetingTasks[meetingId].boardTasks[
            Number(oldTask.taskTypeId)
          ] as unknown) as ISimpleTasks;
          if (isActive(oldTask)) {
            taskStatuses.active = removeTaskIdFromList('active', taskStatuses, oldTask.id);
            newMeetingTasks[meetingId].boardTasks[Number(oldTask.taskTypeId)] = (taskStatuses as unknown) as IBoardItem;
          } else {
            taskStatuses.done = removeTaskIdFromList('done', taskStatuses, oldTask.id);
            newMeetingTasks[meetingId].boardTasks[Number(oldTask.taskTypeId)] = (taskStatuses as unknown) as IBoardItem;
          }
        }
      }
      meetingTasksIds[meetingId].boardTasks = newMeetingTasks[meetingId].boardTasks;
    });
    oldTask.meetingIds.forEach((meetingId) => {
      if (isActionItem(oldTask)) {
        if (oldTask.members.length !== 0) {
          oldTask.members.forEach((member) => {
            if (!!newMeetingTasks[meetingId].actionItems[Number(member)]) {
              const taskStatuses = (newMeetingTasks[meetingId].actionItems[Number(member)] as unknown) as ISimpleTasks;
              if (isActive(oldTask)) {
                taskStatuses.active = removeTaskIdFromList('active', taskStatuses, oldTask.id);
                newMeetingTasks[meetingId].actionItems[Number(member)] = (taskStatuses as unknown) as IMeetingItem;
              } else {
                taskStatuses.done = removeTaskIdFromList('done', taskStatuses, oldTask.id);
                newMeetingTasks[meetingId].actionItems[Number(member)] = (taskStatuses as unknown) as IMeetingItem;
              }
            }
          });
        }
      }
      meetingTasksIds[meetingId].actionItems = newMeetingTasks[meetingId].actionItems;
    });

    oldTask.meetingIds.forEach((meetingId) => {
      if (isGoal(oldTask) && !!oldTask.taskTypeId) {
        if (!!newMeetingTasks[meetingId].goals[Number(oldTask.userId)]) {
          const taskStatuses = (newMeetingTasks[meetingId].goals[Number(oldTask.userId)] as unknown) as ISimpleTasks;
          if (isActive(oldTask)) {
            taskStatuses.active = removeTaskIdFromList('active', taskStatuses, oldTask.id);
            newMeetingTasks[meetingId].goals[Number(oldTask.userId)] = (taskStatuses as unknown) as IMeetingItem;
          } else {
            taskStatuses.done = removeTaskIdFromList('done', taskStatuses, oldTask.id);
            newMeetingTasks[meetingId].goals[Number(oldTask.userId)] = (taskStatuses as unknown) as IMeetingItem;
          }
        }
      }
      meetingTasksIds[meetingId].goals = newMeetingTasks[meetingId].goals;
    });

    yield put(actionsMeetingTasks.storeMeetingTasks(meetingTasksIds));

    const notif: INotification = {
      id: String(Math.floor(Math.random() * 10000)),
      meetingId: oldTask.meetingIds[0],
      senderId: payload.changedBy,
      receiverId: loggedUserId,
      message: 'The card was deleted',
      createdAt: payload.notificationCreatedAt,
    };

    yield call(storeNewPusherNotification, notif);
  }
}

export function* taskDnd(result: DropResult, meetingId: IMeetingSimple['id']) {
  const destination = result.destination?.droppableId.split('-');
  const taskId = result.draggableId;
  const newTaskTypeId = destination ? destination[1] : '';
  const destinationStatus = destination ? (destination[0] === 'active' ? '0' : '1') : '';
  const task: ITaskSimple = yield selectWithParams(taskSimpleSelectors.selectResourceById, taskId);

  const meetingTasksIds = (yield select(meetingTasksPageSelectors.selectMeetingTasks)) as IMeetingTasks;

  // Cannot mark a locked task as done
  if (destinationStatus === '1' && task.isLocked) {
    return;
  }

  const updatedTask = {
    ...task,
    status: destinationStatus,
    taskTypeId: newTaskTypeId,
    labels: task.labels,
    sort: String(result.destination?.index),
  } as ITaskSimpleFromNotification;

  if (result.destination) {
    reorderMeetingTasks(meetingTasksIds, meetingId, task, updatedTask, result.destination?.index);
  }

  const data: ISaveTaskOrder = {
    moved_task_id: taskId,
    destination_board_list_id: newTaskTypeId,
    destination_position: result.destination?.index ?? 0,
    destination_status: destinationStatus === '0' ? 0 : 1,
  };

  yield call(taskSimpleResourceService.storeTaskSimple, updatedTask as ITaskSimple);
  yield call(taskSimpleResourceService.saveTaskOrder, newTaskTypeId, data);
  yield put(actionsMeetingTasks.storeMeetingTasks(meetingTasksIds));
}

export function* saveTaskOrderSocket(payload: types.ISaveTaskOrderNotificationPayload) {
  const {
    destinationBoardListId,
    destinationStatus,
    destinationPosition,
    meetingIds,
    movedTask,
    actionUserId,
  } = payload;
  const loggedUserId: IUser['id'] = yield select(authSelectors.selectLoggedUser);
  // same user who moved the card
  if (String(actionUserId) === String(loggedUserId)) {
    return;
  }
  const meetingTasksIds = (yield select(meetingTasksPageSelectors.selectMeetingTasks)) as IMeetingTasks;
  const oldTask: ITaskSimple = yield selectWithParams(taskSimpleSelectors.selectResourceById, movedTask.id);

  // if task is not loaded in store
  if (!meetingTasksIds[meetingIds[0]]) {
    return;
  }

  // Merge notification data with existing task to preserve all fields
  const updatedTask = {
    ...oldTask,
    ...movedTask,
    status: String(destinationStatus),
    taskTypeId: destinationBoardListId,
    sort: String(destinationPosition),
    labels: movedTask.labels ?? oldTask.labels ?? [],
  } as ITaskSimpleUpdate;

  reorderMeetingTasks(
    meetingTasksIds,
    meetingIds[0],
    oldTask,
    movedTask as ITaskSimpleFromNotification,
    destinationPosition,
  );

  yield call(taskSimpleResourceService.storeTaskSimple, updatedTask as ITaskSimple);
  yield put(actionsMeetingTasks.storeMeetingTasks(meetingTasksIds));
}

function reorderMeetingTasks(
  meetingTasksIds: IMeetingTasks,
  meetingId: IMeetingSimple['id'],
  oldTask: ITaskSimple,
  movedTask: ITaskSimpleFromNotification,
  indexInList: number,
) {
  moveTaskToAnotherList(movedTask, oldTask, meetingTasksIds, indexInList);

  const taskId = oldTask.id;

  // ---- Prepare calendar
  if (movedTask.dueDate) {
    const dueDate = movedTask.dueDate.slice(0, 10);

    // can be null if task is not loaded in store yet because user didn't enter meeting dashboard
    if (!!meetingTasksIds[meetingId].calendarTasks[dueDate]) {
      const previousTaskIdsByStatus = (meetingTasksIds[meetingId].calendarTasks[dueDate] as unknown) as ISimpleTasks;
      previousTaskIdsByStatus.active = removeTaskIdFromList('active', previousTaskIdsByStatus, taskId);
      previousTaskIdsByStatus.done = removeTaskIdFromList('done', previousTaskIdsByStatus, taskId);
    } else {
      meetingTasksIds[meetingId].calendarTasks[dueDate] = { active: [], done: [] };
    }

    if (!!meetingTasksIds[meetingId].calendarTasks[dueDate]) {
      const calendarTasksByStatus = (meetingTasksIds[meetingId].calendarTasks[dueDate] as unknown) as ISimpleTasks;
      if (isActive(movedTask)) {
        calendarTasksByStatus.active.push(taskId);
      } else {
        calendarTasksByStatus.done.push(taskId);
      }
    }
  }

  // ---- Prepare Action Items
  if (movedTask.members) {
    movedTask.members.forEach((member) => {
      const previousTaskIdsByStatus = (meetingTasksIds[meetingId].actionItems[member] as unknown) as ISimpleTasks;
      // continue if there is in fact an Action Item for this member
      if (previousTaskIdsByStatus) {
        // We removed the moved task id from the action item lists first
        previousTaskIdsByStatus.active = removeTaskIdFromList('active', previousTaskIdsByStatus, taskId);
        previousTaskIdsByStatus.done = removeTaskIdFromList('done', previousTaskIdsByStatus, taskId);
        if (isActionItem(movedTask)) {
          if (isActive(movedTask)) {
            previousTaskIdsByStatus.active.push(taskId);
          } else {
            previousTaskIdsByStatus.done.push(taskId);
          }
          meetingTasksIds[meetingId].actionItems[Number(member)] = (previousTaskIdsByStatus as unknown) as IBoardItem;
        }
      }
    });
  }
}

export function* saveTaskOrder(taskTypeId: IBoardList['id'], data: ISaveTaskOrder) {
  yield call(apiRequest, api.updateTaskOrderApi(taskTypeId, data));
}

export function* setupSharedTask(id: ITaskSimple['id']) {
  yield call(taskSimpleResourceService.getSharedTask, id);
}

export function* getTaskWatchers(taskId: ITaskSimple['id']) {
  const loggedUserId = (yield select(authSelectors.selectLoggedUser)) as IUser['id'];
  const response = yield call(taskSimpleResourceService.getTaskWatchers, taskId);
  let watcher = false;
  response.forEach((res: { id: IUser['id'] }) => {
    if (res.id === loggedUserId) {
      watcher = true;
      return;
    }
  });
  yield put(actions.storeWatcher(watcher ? loggedUserId : ''));
}

export function* addTaskWatcher(taskId: ITaskSimple['id']) {
  const loggedUserId = (yield select(authSelectors.selectLoggedUser)) as IUser['id'];
  const response = yield call(taskSimpleResourceService.addTaskWatcher, taskId, [loggedUserId]);
  let watcher = false;
  response.forEach((res: { id: IUser['id'] }) => {
    if (res.id === loggedUserId) {
      watcher = true;
      return;
    }
  });
  yield put(actions.storeWatcher(watcher ? loggedUserId : ''));
}

export function* deleteTaskWatcher(taskId: ITaskSimple['id']) {
  const loggedUserId = (yield select(authSelectors.selectLoggedUser)) as IUser['id'];
  yield call(taskSimpleResourceService.removeTaskWatcher, taskId, loggedUserId);

  //const watcher = response.length > 0 ? response[0].id : '';
  yield put(actions.clearWatcher());
}

export function* addTaskAttachment(taskId: ITaskSimple['id'], data: IAddAttachmentForm) {
  const res = (yield call(apiRequest, api.addTaskAttachmentApi(taskId, data))) as { activity: IActivity };

  const activity = res.activity as IActivity;
  if (!activity) {
    return;
  }

  yield call(storeActivity, activity);
  const activitiesIds = (yield select(activitiesPageSelectors.selectActivities)) as IActivity['id'][];
  yield put(activitiesIds ? storeActivities([...activitiesIds, activity.id]) : clearActivity());
  yield put(clearTaskModalStatuses());
}

export function* initializeTaskProps(taskId: ITaskSimple['id']) {
  yield all(
    [checkListService.setupCheckLists, activitiesService.setupActivities, getTaskWatchers].map((func) =>
      call(func, taskId),
    ),
  );
}

export function* clearTaskProps() {
  yield call(checkListService.clearCheckListsPageStorage);
  yield call(activitiesService.clearActivitiesPageStorage);
  yield call(dialogService.closeDialog, 'trelloReplacementFormDialog');
}

export const mapTaskSimpleFormToTaskSimpleCreate = (taskInfo: ITaskSimpleCreateForm): ITaskSimpleCreate => ({
  title: taskInfo.title,
  description: taskInfo.description,
  dueDate: taskInfo.dueDate ? moment(taskInfo.dueDate).format('YYYY-MM-DD') : undefined,
  reminder: taskInfo.reminder ? taskInfo.reminder.value : '',
  userId: taskInfo.user.value,
  meetingIds: taskInfo.meeting.map((m) => m.value),
  type: taskInfo.type,
  status: taskInfo.status ? taskInfo.status.value : '0',
  labels: [],
  taskTypeId: taskInfo.taskTypeId,
  members: [],
  showInTasks: taskInfo.showInTasks ? taskInfo.showInTasks : '0',
  boardId: taskInfo.boardId,
  quarterId: taskInfo.quarter ? taskInfo.quarter.value : undefined,
});

export function* clearTasksSimplePageStorage() {
  yield put(actions.clearTaskSimple());
}

/** Internal function designed to re-use code */
function* addGoalToStore(goal: ITaskSimpleFromNotification, meetingTasksIds: IMeetingTasks) {
  const loggedUserId = (yield select(authSelectors.selectLoggedUser)) as IUser['id'];
  // goals showed in personal dashboard for logged user
  const myGoals = (yield select(tasksSimplePageSelectors.selectQis)) as ISimpleTasks;
  if (goal.userId === loggedUserId) {
    if (isActive(goal)) {
      if (!myGoals.active.includes(goal.id)) {
        myGoals.active.push(goal.id);
      }
    } else {
      if (!myGoals.done.includes(goal.id)) {
        myGoals.done.push(goal.id);
      }
    }

    yield put(actionsTaskSimple.storeQi(myGoals));
  }

  goal.meetingIds.forEach((meetingId: IMeetingSimple['id']) => {
    // if meeting doesn't exist in store we do nothing.
    if (!meetingTasksIds[meetingId]) {
      return;
    }
    if (!!meetingTasksIds[meetingId].goals[Number(goal.userId)]) {
      const goalStatuses = (meetingTasksIds[meetingId].goals[Number(goal.userId)] as unknown) as ISimpleTasks;
      if (isActive(goal)) {
        goalStatuses.active.push(goal.id);
      } else {
        goalStatuses.done.push(goal.id);
      }
    } else {
      const goalStatuses: ISimpleTasks = { active: [], done: [] };
      if (isActive(goal)) {
        goalStatuses.active.push(goal.id);
      } else {
        goalStatuses.done.push(goal.id);
      }
      meetingTasksIds[meetingId].goals[Number(goal.userId)] = (goalStatuses as unknown) as IMeetingItem;
    }

    addElementToCalendar(goal, meetingTasksIds, meetingId);
  });

  yield put(actionsMeetingTasks.storeMeetingTasks(meetingTasksIds));
}

/** Internal function designed to re-use code */
function* updateGoalInStore(
  updatedTask: ITaskSimpleFromNotification,
  oldTask: ITaskSimple,
  meetingTasksIds: IMeetingTasks,
) {
  const meetingsChanged = updatedTask.meetingIds.sort().join(',') !== oldTask.meetingIds.sort().join(',');
  if (meetingsChanged) {
    updateMeetings(updatedTask, oldTask, meetingTasksIds);
  }

  updatedTask.meetingIds.forEach((meetingId: IMeeting['id']) => {
    if (!meetingTasksIds[meetingId]) {
      return;
    }
    if (oldTask.status !== updatedTask.status) {
      if (!!meetingTasksIds[meetingId]) {
        if (!!meetingTasksIds[meetingId].goals[Number(updatedTask.userId)]) {
          const taskStatuses = (meetingTasksIds[meetingId].goals[
            Number(updatedTask.userId)
          ] as unknown) as ISimpleTasks;
          if (isActive(updatedTask)) {
            if (!taskStatuses.active.includes(updatedTask.id)) {
              taskStatuses.active.push(updatedTask.id);
            }
            taskStatuses.done = removeTaskIdFromList('done', taskStatuses, updatedTask.id);
            meetingTasksIds[meetingId].goals[Number(updatedTask.userId)] = (taskStatuses as unknown) as IMeetingItem;
          } else {
            taskStatuses.active = removeTaskIdFromList('active', taskStatuses, updatedTask.id);
            if (!taskStatuses.done.includes(updatedTask.id)) {
              taskStatuses.done.push(updatedTask.id);
            }
            meetingTasksIds[meetingId].goals[Number(updatedTask.userId)] = (taskStatuses as unknown) as IMeetingItem;
          }
        }
      }
    }

    if (oldTask.userId !== updatedTask.userId) {
      if (!!meetingTasksIds[meetingId].goals[Number(oldTask.userId)]) {
        const taskStatuses = (meetingTasksIds[meetingId].goals[Number(oldTask.userId)] as unknown) as ISimpleTasks;
        if (isActive(oldTask)) {
          taskStatuses.active = removeTaskIdFromList('active', taskStatuses, oldTask.id);
          meetingTasksIds[meetingId].goals[Number(oldTask.userId)] = (taskStatuses as unknown) as IMeetingItem;
        } else {
          taskStatuses.done = removeTaskIdFromList('done', taskStatuses, oldTask.id);
          meetingTasksIds[meetingId].goals[Number(oldTask.userId)] = (taskStatuses as unknown) as IMeetingItem;
        }
      }
      if (!!meetingTasksIds[meetingId].goals[Number(updatedTask.userId)]) {
        const taskStatuses = (meetingTasksIds[meetingId].goals[Number(updatedTask.userId)] as unknown) as ISimpleTasks;
        if (isActive(updatedTask)) {
          if (!taskStatuses.active.includes(updatedTask.id)) {
            taskStatuses.active.push(updatedTask.id);
          }
          meetingTasksIds[meetingId].goals[Number(updatedTask.userId)] = (taskStatuses as unknown) as IMeetingItem;
        } else {
          if (!taskStatuses.done.includes(updatedTask.id)) {
            taskStatuses.done.push(updatedTask.id);
          }
          meetingTasksIds[meetingId].goals[Number(updatedTask.userId)] = (taskStatuses as unknown) as IMeetingItem;
        }
      } else {
        const goals: ISimpleTasks = { active: [], done: [] };
        if (isActive(updatedTask)) {
          goals.active.push(updatedTask.id);
        } else {
          goals.done.push(updatedTask.id);
        }
        meetingTasksIds[meetingId].goals[Number(updatedTask.userId)] = (goals as unknown) as IMeetingItem;
      }
    }

    if (oldTask.dueDate !== updatedTask.dueDate) {
      updateDueDateInCalendarTasks(updatedTask, oldTask, meetingTasksIds, meetingId);
    }
  });

  const myGoals = (yield select(tasksSimplePageSelectors.selectQis)) as ISimpleTasks;
  const newGoals = { ...myGoals };
  const loggedUserId: IUser['id'] = yield select(authSelectors.selectLoggedUser);

  if (oldTask.userId !== updatedTask.userId) {
    // unassigning to old user
    if (oldTask.userId === loggedUserId) {
      if (isActive(oldTask)) {
        newGoals.active = removeTaskIdFromList('active', newGoals, oldTask.id);
      } else {
        newGoals.done = removeTaskIdFromList('done', newGoals, oldTask.id);
      }
    }
    // assigning to new user
    if (updatedTask.userId === loggedUserId) {
      if (isActive(updatedTask)) {
        if (!newGoals.active.includes(updatedTask.id)) {
          newGoals.active.push(updatedTask.id);
        }
      } else {
        if (!newGoals.done.includes(updatedTask.id)) {
          newGoals.done.push(updatedTask.id);
        }
      }
    }
    // it's important that next line be else if
  } else if (oldTask.status !== updatedTask.status) {
    if (oldTask.userId === loggedUserId) {
      if (isActive(oldTask) && !isActive(updatedTask)) {
        newGoals.active = removeTaskIdFromList('active', newGoals, oldTask.id);
        if (!newGoals.done.includes(updatedTask.id)) {
          newGoals.done.push(updatedTask.id);
        }
      } else if (!isActive(oldTask) && isActive(updatedTask)) {
        newGoals.done = removeTaskIdFromList('done', newGoals, oldTask.id);
        if (!newGoals.active.includes(updatedTask.id)) {
          newGoals.active.push(updatedTask.id);
        }
      }
    }
  }

  yield put(actionsTaskSimple.storeQi(newGoals));

  yield put(actionsMeetingTasks.storeMeetingTasks(meetingTasksIds));
  yield call(taskSimpleResourceService.storeTaskSimple, updatedTask as ITaskSimple);
}

/** Internal function designed to re-use code */
function* addTaskToStore(task: ITaskSimpleFromNotification, meetingTasksIds: IMeetingTasks) {
  const loggedUserId = (yield select(authSelectors.selectLoggedUser)) as IUser['id'];
  // tasks showed in personal dashboard
  const myTasks = (yield select(tasksSimplePageSelectors.selectMyTasks)) as ISimpleTasks;
  if (task.members.includes(loggedUserId)) {
    myTasks.active.push(task.id);
    yield put(actionsTaskSimple.storeTasksSimple(myTasks));
  }

  task.meetingIds.forEach((meetingId: IMeeting['id']) => {
    if (!meetingTasksIds[meetingId]) {
      return;
    }
    if (isActionItem(task)) {
      updateActionItemStatus(task, meetingTasksIds, meetingId);
    }

    if (!!meetingTasksIds[meetingId].boardTasks[Number(task.taskTypeId)]) {
      const taskStatuses = (meetingTasksIds[meetingId].boardTasks[Number(task.taskTypeId)] as unknown) as ISimpleTasks;
      if (isActive(task)) {
        taskStatuses.active.push(task.id);
        meetingTasksIds[meetingId].boardTasks[Number(task.taskTypeId)] = (taskStatuses as unknown) as IBoardItem;
      } else {
        taskStatuses.done.push(task.id);
        meetingTasksIds[meetingId].boardTasks[Number(task.taskTypeId)] = (taskStatuses as unknown) as IBoardItem;
      }
    } else {
      const taskStatuses: ISimpleTasks = { active: [], done: [] };
      if (isActive(task)) {
        taskStatuses.active.push(task.id);
      } else {
        taskStatuses.done.push(task.id);
      }
      meetingTasksIds[meetingId].boardTasks[Number(task.taskTypeId)] = (taskStatuses as unknown) as IBoardItem;
    }
  });

  yield put(actionsMeetingTasks.storeMeetingTasks(meetingTasksIds));
}

function updateBoardTaskStatus(
  task: ITaskSimpleFromNotification,
  meetingTasksIds: IMeetingTasks,
  meetingId: IMeetingSimple['id'],
) {
  if (!!meetingTasksIds[meetingId].boardTasks[Number(task.taskTypeId)]) {
    const taskIdsByStatus = (meetingTasksIds[meetingId].boardTasks[Number(task.taskTypeId)] as unknown) as ISimpleTasks;
    if (isActive(task)) {
      if (!taskIdsByStatus.active.includes(task.id)) {
        taskIdsByStatus.active.push(task.id);
      }
      taskIdsByStatus.done = removeTaskIdFromList('done', taskIdsByStatus, task.id);
      meetingTasksIds[meetingId].boardTasks[Number(task.taskTypeId)] = (taskIdsByStatus as unknown) as IBoardItem;
    } else {
      taskIdsByStatus.active = removeTaskIdFromList('active', taskIdsByStatus, task.id);
      if (!taskIdsByStatus.done.includes(task.id)) {
        taskIdsByStatus.done.unshift(task.id);
      }
      meetingTasksIds[meetingId].boardTasks[Number(task.taskTypeId)] = (taskIdsByStatus as unknown) as IBoardItem;
    }
  }
}

/** Internal function designed to re-use code */
function* updateTaskInStore(
  updatedTask: ITaskSimpleFromNotification,
  oldTask: ITaskSimple,
  meetingTasksIds: IMeetingTasks,
) {
  if (oldTask.taskTypeId !== updatedTask.taskTypeId) {
    moveTaskToAnotherList(updatedTask, oldTask, meetingTasksIds, 0);
  }

  updatedTask.meetingIds.forEach((meetingId: IMeeting['id']) => {
    if (!meetingTasksIds[meetingId]) {
      return;
    }

    // for some reason, updateTask.status may be number when moving a card with move button
    if (oldTask.status !== String(updatedTask.status)) {
      updateCalendarTaskStatus(updatedTask, meetingTasksIds, meetingId);
      updateBoardTaskStatus(updatedTask, meetingTasksIds, meetingId);
      if (isActionItem(updatedTask)) {
        updateActionItemStatus(updatedTask, meetingTasksIds, meetingId);
      }
    }
    if (oldTask.dueDate !== updatedTask.dueDate) {
      updateDueDateInCalendarTasks(updatedTask, oldTask, meetingTasksIds, meetingId);
    }

    if (oldTask.showInTasks !== updatedTask.showInTasks) {
      if (isActionItem(updatedTask)) {
        if (updatedTask.members.length !== 0) {
          updatedTask.members.forEach((member: string) => {
            if (!!meetingTasksIds[meetingId].actionItems[Number(member)]) {
              const taskStatuses = (meetingTasksIds[meetingId].actionItems[Number(member)] as unknown) as ISimpleTasks;
              if (isActive(updatedTask)) {
                if (!taskStatuses.active.includes(updatedTask.id)) {
                  taskStatuses.active.push(updatedTask.id);
                }
              } else {
                if (!taskStatuses.done.includes(updatedTask.id)) {
                  taskStatuses.done.unshift(updatedTask.id);
                }
              }
            } else {
              const taskStatuses: ISimpleTasks = { active: [], done: [] };
              if (isActive(updatedTask)) {
                taskStatuses.active.push(updatedTask.id);
              } else {
                taskStatuses.done.unshift(updatedTask.id);
              }
              meetingTasksIds[meetingId].actionItems[Number(member)] = (taskStatuses as unknown) as IMeetingItem;
            }
          });
        }
      } else {
        if (updatedTask.members.length !== 0) {
          updatedTask.members.forEach((member: string) => {
            if (!!meetingTasksIds[meetingId].actionItems[Number(member)]) {
              const taskStatuses = (meetingTasksIds[meetingId].actionItems[Number(member)] as unknown) as ISimpleTasks;
              if (isActive(updatedTask)) {
                taskStatuses.active = removeTaskIdFromList('active', taskStatuses, updatedTask.id);
                meetingTasksIds[meetingId].actionItems[Number(member)] = (taskStatuses as unknown) as IMeetingItem;
              } else {
                taskStatuses.done = removeTaskIdFromList('done', taskStatuses, updatedTask.id);
                meetingTasksIds[meetingId].actionItems[Number(member)] = (taskStatuses as unknown) as IMeetingItem;
              }
            }
          });
        }
      }
    }
  });

  if (JSON.stringify(oldTask.members) !== JSON.stringify(updatedTask.members)) {
    oldTask.meetingIds.forEach((meetingId: IMeeting['id']) => {
      if (!meetingTasksIds[meetingId]) {
        return;
      }
      if (isActionItem(oldTask)) {
        if (oldTask.members.length !== 0) {
          oldTask.members.forEach((member: string) => {
            if (!!meetingTasksIds[meetingId].actionItems[Number(member)]) {
              const tasks = (meetingTasksIds[meetingId].actionItems[Number(member)] as unknown) as ISimpleTasks;
              if (isActive(oldTask)) {
                tasks.active = removeTaskIdFromList('active', tasks, oldTask.id);
              } else {
                tasks.done = removeTaskIdFromList('done', tasks, oldTask.id);
              }
            }
          });
        }
      }
    });
    updatedTask.meetingIds.forEach((meetingId: IMeeting['id']) => {
      if (!meetingTasksIds[meetingId]) {
        return;
      }
      if (isActionItem(updatedTask)) {
        if (updatedTask.members.length !== 0) {
          updatedTask.members.forEach((member: string) => {
            if (!!meetingTasksIds[meetingId].actionItems[Number(member)]) {
              const taskStatuses = (meetingTasksIds[meetingId].actionItems[Number(member)] as unknown) as ISimpleTasks;
              if (isActive(updatedTask)) {
                if (!taskStatuses.active.includes(updatedTask.id)) {
                  taskStatuses.active.push(updatedTask.id);
                }
              } else {
                if (!taskStatuses.done.includes(updatedTask.id)) {
                  taskStatuses.done.unshift(updatedTask.id);
                }
              }
            } else {
              const taskStatuses: ISimpleTasks = { active: [], done: [] };
              if (isActive(updatedTask)) {
                taskStatuses.active.push(updatedTask.id);
              } else {
                taskStatuses.done.unshift(updatedTask.id);
              }
              meetingTasksIds[meetingId].actionItems[Number(member)] = (taskStatuses as unknown) as IMeetingItem;
            }
          });
        }
      }
    });
  }

  yield put(actionsMeetingTasks.storeMeetingTasks(meetingTasksIds));
  yield call(taskSimpleResourceService.storeTaskSimple, updatedTask as ITaskSimple);
}

function updateDueDateInCalendarTasks(
  updatedTask: ITaskSimpleFromNotification,
  oldTask: ITaskSimple,
  meetingTasksIds: IMeetingTasks,
  meetingId: IMeeting['id'],
) {
  removeElementFromCalendar(oldTask, meetingTasksIds, meetingId);
  addElementToCalendar(updatedTask, meetingTasksIds, meetingId);
}

function updateMeetings(
  updatedTask: ITaskSimpleFromNotification,
  oldTask: ITaskSimple,
  meetingTasksIds: IMeetingTasks,
) {
  const taskId = updatedTask.id;

  //remove previous meetings this goal was assigned to
  oldTask.meetingIds.forEach((meetingId: string) => {
    if (!meetingTasksIds[meetingId]) {
      return;
    }
    const previousGoalsIdsByStatus = (meetingTasksIds[meetingId].goals[
      Number(oldTask.userId)
    ] as unknown) as ISimpleTasks;
    previousGoalsIdsByStatus.active = removeTaskIdFromList('active', previousGoalsIdsByStatus, taskId);
    previousGoalsIdsByStatus.done = removeTaskIdFromList('done', previousGoalsIdsByStatus, taskId);

    removeElementFromCalendar(oldTask, meetingTasksIds, meetingId);
  });

  updatedTask.meetingIds.forEach((meetingId: string) => {
    if (!meetingTasksIds[meetingId]) {
      meetingTasksIds[meetingId] = {
        actionItems: {} as IMeetingItem[],
        goals: {} as IMeetingItem[],
        calendarTasks: {} as ICalendarItem[],
        boardTasks: {} as IBoardItem[],
      };
    }

    if (!!meetingTasksIds[meetingId].goals[Number(updatedTask.userId)]) {
      const goalStatuses = (meetingTasksIds[meetingId].goals[Number(updatedTask.userId)] as unknown) as ISimpleTasks;
      if (isActive(updatedTask)) {
        goalStatuses.active.push(taskId);
      } else {
        goalStatuses.done.push(taskId);
      }
    } else {
      const goalStatuses: ISimpleTasks = { active: [], done: [] };
      if (isActive(updatedTask)) {
        goalStatuses.active.push(taskId);
      } else {
        goalStatuses.done.push(taskId);
      }

      meetingTasksIds[meetingId].goals[Number(updatedTask.userId)] = (goalStatuses as unknown) as IMeetingItem;
    }
    addElementToCalendar(updatedTask, meetingTasksIds, meetingId);
  });
}

function addElementToCalendar(
  updatedTask: ITaskSimpleFromNotification,
  meetingTasksIds: IMeetingTasks,
  meetingId: IMeeting['id'],
) {
  if (updatedTask.dueDate) {
    const dueDate = updatedTask.dueDate.slice(0, 10);
    if (!!meetingTasksIds[meetingId].calendarTasks[dueDate]) {
      const calendarTasksByStatus = (meetingTasksIds[meetingId].calendarTasks[dueDate] as unknown) as ISimpleTasks;
      if (isActive(updatedTask)) {
        calendarTasksByStatus.active.push(updatedTask.id);
      } else {
        calendarTasksByStatus.done.push(updatedTask.id);
      }
    } else {
      const calendarTasks: ISimpleTasks = { active: [], done: [] };
      if (isActive(updatedTask)) {
        calendarTasks.active.push(updatedTask.id);
      } else {
        calendarTasks.done.push(updatedTask.id);
      }
      meetingTasksIds[meetingId].calendarTasks[dueDate] = (calendarTasks as unknown) as IMeetingItem;
    }
  }
}

function removeElementFromCalendar(task: ITaskSimple, meetingTasksIds: IMeetingTasks, meetingId: IMeeting['id']) {
  if (task.dueDate) {
    const dueDate = task.dueDate.slice(0, 10);
    const previousGoalsIdsByStatus = (meetingTasksIds[meetingId].calendarTasks[dueDate] as unknown) as ISimpleTasks;
    if (previousGoalsIdsByStatus) {
      previousGoalsIdsByStatus.active = removeTaskIdFromList('active', previousGoalsIdsByStatus, task.id);
      previousGoalsIdsByStatus.done = removeTaskIdFromList('done', previousGoalsIdsByStatus, task.id);
    }
  }
}

function updateCalendarTaskStatus(
  task: ITaskSimpleFromNotification,
  meetingTasksIds: IMeetingTasks,
  meetingId: IMeetingSimple['id'],
) {
  if (task.dueDate) {
    const dueDate = task.dueDate.slice(0, 10);
    if (!!meetingTasksIds[meetingId].calendarTasks[dueDate]) {
      const calendarTasksByStatus = (meetingTasksIds[meetingId].calendarTasks[dueDate] as unknown) as ISimpleTasks;
      if (isActive(task)) {
        calendarTasksByStatus.done = removeTaskIdFromList('done', calendarTasksByStatus, task.id);
        calendarTasksByStatus.active.push(task.id);
      } else {
        calendarTasksByStatus.active = removeTaskIdFromList('active', calendarTasksByStatus, task.id);
        calendarTasksByStatus.done.push(task.id);
      }
    }
  }
}

function updateActionItemStatus(
  task: ITaskSimpleFromNotification,
  meetingTasksIds: IMeetingTasks,
  meetingId: IMeetingSimple['id'],
) {
  if (task.members.length !== 0) {
    task.members.forEach((member: string) => {
      if (!!meetingTasksIds[meetingId].actionItems[Number(member)]) {
        const taskStatuses = (meetingTasksIds[meetingId].actionItems[Number(member)] as unknown) as ISimpleTasks;
        if (isActive(task)) {
          if (!taskStatuses.active.includes(task.id)) {
            taskStatuses.active.push(task.id);
          }
          taskStatuses.done = removeTaskIdFromList('done', taskStatuses, task.id);
        } else {
          taskStatuses.active = removeTaskIdFromList('active', taskStatuses, task.id);
          if (!taskStatuses.done.includes(task.id)) {
            taskStatuses.done.unshift(task.id);
          }
        }
      } else {
        const taskStatuses: ISimpleTasks = { active: [], done: [] };
        if (isActive(task)) {
          taskStatuses.active.push(task.id);
        } else {
          taskStatuses.done.unshift(task.id);
        }
        meetingTasksIds[meetingId].actionItems[Number(member)] = (taskStatuses as unknown) as IMeetingItem;
      }
    });
  }
}

function moveTaskToAnotherList(
  updatedTask: ITaskSimpleFromNotification,
  oldTask: ITaskSimple,
  meetingTasksIds: IMeetingTasks,
  indexInList: number,
) {
  if (oldTask) {
    const oldTaskMeetingId = oldTask.meetingIds[0];

    if (
      meetingTasksIds[oldTaskMeetingId] &&
      !!meetingTasksIds[oldTaskMeetingId].boardTasks[Number(oldTask.taskTypeId)]
    ) {
      const previousTaskIdsByStatus = (meetingTasksIds[oldTaskMeetingId].boardTasks[
        Number(oldTask.taskTypeId)
      ] as unknown) as ISimpleTasks;

      previousTaskIdsByStatus.active = removeTaskIdFromList('active', previousTaskIdsByStatus, oldTask.id);
      previousTaskIdsByStatus.done = removeTaskIdFromList('done', previousTaskIdsByStatus, oldTask.id);
    }
  }

  const updateTaskMeetingId = updatedTask.meetingIds[0];
  if (!meetingTasksIds[updateTaskMeetingId]) {
    return;
  }

  let taskIdsByStatus = (meetingTasksIds[updateTaskMeetingId].boardTasks[
    Number(updatedTask.taskTypeId)
  ] as unknown) as ISimpleTasks;
  if (!taskIdsByStatus) {
    taskIdsByStatus = { active: [], done: [] };
    meetingTasksIds[updateTaskMeetingId].boardTasks[
      Number(updatedTask.taskTypeId)
    ] = (taskIdsByStatus as unknown) as IBoardItem;
  }
  if (isActive(updatedTask)) {
    insertElementInList(taskIdsByStatus.active, indexInList, updatedTask.id);
  } else {
    insertElementInList(taskIdsByStatus.done, indexInList, updatedTask.id);
  }
}

function removeTaskIdFromList(type: string, obj: ISimpleTasks, taskId: string) {
  return obj[type].filter((id: string) => id !== taskId);
}

function insertElementInList(list: string[], index: number, taskId: ITaskSimple['id']) {
  list.splice(index, 0, taskId);
}

export function isActive(task: ITaskSimple | ITaskSimpleUpdate | ITaskSimpleCreate) {
  // active tasks: status === '0', active goals: status === '0' (on track) and status === '2' (off track)
  if (task.taskTypeId === '1') {
    return String(task.status) !== '1' && String(task.status) !== '3';
  }
  return String(task.status) !== '1';
}

export function isActionItem(task: ITaskSimple | ITaskSimpleUpdate) {
  return task.showInTasks === '1';
}

export function isGoal(task: ITaskSimple) {
  return task.taskTypeId === '1';
}
